"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType["awaited"] = "awaited";
})(InputType || (exports.InputType = InputType = {}));
//# sourceMappingURL=search.js.map